import * as types from "../actions/ActionTypes"
import initialState from "./initialState"
import {
    API_CALL_STARTED,
    API_CALL_ERROR,
    API_CALL_SUCCESS, API_CALL_CANCELED
} from '../actions/ApiCallsActions';

export default function (state = initialState.apiCallsInProgressCount, action) {
    if (action.type.includes(API_CALL_STARTED)) {
        // when a api call starts increment the number of calls
        return state + 1
    } else if (action.type.includes(API_CALL_ERROR) || action.type.includes(API_CALL_SUCCESS) || action.type.includes(API_CALL_CANCELED) ) {
        // Decrement api calls count on successful calls or error
        return state - 1;
    } else {
        return state
    }
}
